export enum PauseState {
  NOT_PAUSED,
  PAUSE_PENDING,
  PAUSED,
  RESUME_PENDING,
}

export namespace PauseState {
  let elements = [
    PauseState.NOT_PAUSED,
    PauseState.PAUSE_PENDING,
    PauseState.PAUSED,
    PauseState.RESUME_PENDING,
  ];
  let alias = "com.bcdfx.model.PauseState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
